
import SwipeGesture from '../../utilities/SwipeGesture.vue';
// TODO:BRO-1276: import DModal from '@appsumo/dorado-nuxt';
import LegacyModal from '../../utilities/LegacyModal.vue';
import LegacyModalCloseButton from '../../utilities/LegacyModalCloseButton.vue';

export default {
  components: {
    SwipeGesture,
    LegacyModal,
    LegacyModalCloseButton,
  },
  emits: ['close-modal'],
  props: {
    slides: {
      type: Array,
      default: () => ([]),
    },
    thumbnails: {
      type: Array,
      required: true,
    },
    initialSlide: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      zoom: false,
      hidePrev: true,
      hideNext: true,
      currentSlide: this.initialSlide,
    };
  },
  computed: {
    primarySlide() {
      return this.slides[this.currentSlide];
    },
  },
  mounted() {
    const { scroller } = this.$refs;

    if (scroller) {
      scroller.addEventListener('scroll', this.updateScrollButtons);

      // Wait for CSS to apply styles and enable scroll
      setTimeout(() => {
        this.updateScrollButtons();
        this.adjustFooterCarouselView(this.currentSlide);
      }, 500);
    }
  },
  beforeDestroy() {
    const { scroller } = this.$refs;

    if (scroller) {
      scroller.removeEventListener('scroll', this.updateScrollButtons);
    }
  },
  methods: {
    closeModal() {
      this.$emit('close-modal');
    },
    changeSlide(index) {
      this.adjustFooterCarouselView(index);
      this.currentSlide = index;
    },
    toggleZoom() {
      this.zoom = !this.zoom;
    },
    scrollClick(isNext) {
      const { scroller } = this.$refs;

      const amount = isNext ? 100 : -100;

      if (scroller) {
        scroller.scrollBy({ left: amount, behavior: 'smooth' });
      }
    },
    getScrollDistOnSwipe(targetIndex) {
      // jl: returns the distance *from* left that the footer container should scroll
      // when user swipes main image of the carousel modal. goal here is to center the
      // 'active' image in the footer container
      const { scroller, footerThumbnails } = this.$refs;
      const thumbnailImage = footerThumbnails[targetIndex];

      if (!!scroller && !!thumbnailImage) {
        const footerWidth = scroller.clientWidth;
        const imageWidth = thumbnailImage.clientWidth;
        const imageStyle = thumbnailImage.currentStyle || window.getComputedStyle(thumbnailImage);

        if (imageStyle) {
          // jl: browser will always return px string for 'imageStyle.[property]' (i.e. no 'rem')
          const borderRightWidth = Number(imageStyle.borderRightWidth.replace(/px$/, ''));
          const marginRight = Number(imageStyle.marginRight.replace(/px$/, ''));
          const marginLeft = Number(imageStyle.marginLeft.replace(/px$/, ''));

          // jl: scroll dist to align the target image to the left of the viewport
          const alignThumbnailLeftDist = targetIndex * (
            imageWidth + 2 * (
              borderRightWidth + (marginRight || marginLeft)
            )
          );

          // jl: scroll dist to adjust a thumbnail from left to center of viewport
          const centerThumbnailOffset = 0.5 * (footerWidth - imageWidth);

          return alignThumbnailLeftDist - centerThumbnailOffset;
        }
      }

      return -1;
    },
    adjustFooterCarouselView(index) {
      const { scroller } = this.$refs;

      const amount = this.getScrollDistOnSwipe(index);

      if (scroller && amount !== -1) {
        scroller.scrollTo({ left: amount, behavior: 'smooth' });
      }
    },
    updateScrollButtons() {
      const { scroller } = this.$refs;
      const gutter = 12; // images with 6px left and 6px right
      if (!scroller) return;
      const {
        scrollLeft,
        clientWidth,
        scrollWidth,
      } = scroller;

      this.hidePrev = scrollLeft === 0;
      this.hideNext = scrollLeft + clientWidth + gutter >= scrollWidth;
    },
    isSwipeAllowed() {
      // an: Swipe is not possible when zooming on image
      if (this.zoom) {
        return false;
      }

      const mobileMediaQuery = window.matchMedia('(max-width: 767px)');

      // an: Swipe is only possible on mobile
      return mobileMediaQuery.matches;
    },
    swipeToLeft() {
      if (!this.isSwipeAllowed()) {
        return;
      }

      if (this.currentSlide < this.slides.length - 1) {
        this.changeSlide(this.currentSlide + 1);
        return;
      }

      // an: allow user to see first image if swipping last item
      if (this.currentSlide === this.slides.length - 1) {
        this.changeSlide(0);
      }
    },
    swipeToRight() {
      if (!this.isSwipeAllowed()) {
        return;
      }

      if (this.currentSlide > 0) {
        this.changeSlide(this.currentSlide - 1);
        return;
      }

      // an: allow user to see last item if swipping first item
      if (this.currentSlide === 0) {
        this.changeSlide(this.slides.length - 1);
      }
    },
  },
};
